import { render, staticRenderFns } from "./StepTypeSandbox.vue?vue&type=template&id=1cc18b80&"
import script from "./StepTypeSandbox.vue?vue&type=script&lang=js&"
export * from "./StepTypeSandbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports